import { render, staticRenderFns } from "./MatrixConfig.vue?vue&type=template&id=1d0665a3"
import script from "./MatrixConfig.vue?vue&type=script&lang=js"
export * from "./MatrixConfig.vue?vue&type=script&lang=js"
import style0 from "./MatrixConfig.vue?vue&type=style&index=0&id=1d0665a3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports